import React, { useState } from 'react';
import Plot from 'react-plotly.js';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const { Option } = Select;

const Simulations3DSurface = ({ simulations, assetNames }) => {
    const defaultAssets = assetNames.slice(0, 3); // Default to the first 3 assets if available

    const [selectedAssets, setSelectedAssets] = useState(defaultAssets);

    if (!simulations || simulations.length === 0) {
        return <div>No simulation data available</div>;
    }

    // State to manage the selected assets

    // Extract Z data for the selected assets
    const selectedIndices = selectedAssets.map(asset => assetNames.indexOf(asset));
    const zData = selectedIndices.map(index => simulations[index]);

    // Create X and Y labels
    const xLabels = selectedAssets;
    const yLabels = Array.from({ length: zData.length }, (_, i) => `Sim ${i + 1}`);

    // Handle asset selection change
    const handleSelectChange = (value) => {
        // Limit selection to exactly three assets
        setSelectedAssets(value);
    };

    return (
        <div>
            <Select
                mode="multiple"
                style={{ width: '100%', marginBottom: '20px' }}
                placeholder="Select up to three assets to plot"
                value={selectedAssets}
                onChange={handleSelectChange}
            >
                {assetNames.map((name) => (
                    <Option key={name} value={name}>
                        {name}
                    </Option>
                ))}
            </Select>

            {selectedAssets.length > 0 && (
                <Plot
                    data={[
                        {
                            z: zData,
                            x: xLabels,
                            y: yLabels,
                            type: 'surface',
                            colorscale: 'Viridis', // Use a visually appealing color scale
                        },
                    ]}
                    layout={{
                        autosize: true,
                        width: '100%',
                        height: 500, // Set a fixed height to make the chart more compact
                        margin: {
                            l: 10,  // Left margin to reduce whitespace
                            r: 10,  // Right margin
                            b: 10,  // Bottom margin
                            t: 30,  // Top margin to accommodate the title
                        },
                        scene: {
                            xaxis: { title: 'Assets' },
                            yaxis: { title: 'Simulations' },
                            zaxis: { title: 'Values' },
                            camera: {
                                eye: {
                                    x: 1.2, // Adjust these values for a more zoomed-in view
                                    y: 1.2, // Reduce this to bring the camera closer
                                    z: 0.6, // Reducing this value will make it more zoomed-in
                                },
                                center: {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                },
                                up: {
                                    x: 0,
                                    y: 0,
                                    z: 1,
                                },
                            },
                        },
                    }}
                    config={{ displayModeBar: false }}  // Hide the toolbar
                />
            )}
        </div>
    );
};

Simulations3DSurface.propTypes = {
    simulations: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    assetNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Simulations3DSurface;

// Usage example:
// <Simulations3DSurface simulations={simulationsData} assetNames={['Asset A', 'Asset B', 'Asset C', 'Asset D']} />
